import type { CorePageStoryblok } from '~/types/storyblok-generated';
import type { ModuleTheme } from './module-settings';

const defaultTheme: ModuleTheme = 'brown-light';

export function getThemeOfModule(module: NonNullable<CorePageStoryblok['body']>[number]): ModuleTheme {
  // Special cases
  if (module.component === 'cm_stage') {
    return module.theme === 'red' ? 'schaerer-red' : 'brown-light';
  }
  if (module.component === 'cm_waves') {
    return !!module.theme ? module.theme : 'white';
  }

  if ('is_dark' in module === false) {
    // Default theme is brown-light
    return defaultTheme;
  } else if (module.is_dark === true) {
    return 'brown-light';
  } else {
    return 'white';
  }
}
